import { render } from "./partnerList2.vue?vue&type=template&id=8745391c&scoped=true"
import script from "./partnerList2.vue?vue&type=script&lang=js"
export * from "./partnerList2.vue?vue&type=script&lang=js"

import "./partnerList2.vue?vue&type=style&index=0&id=8745391c&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&id=8745391c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8745391c"]])

export default __exports__